export function verifyCookie(cookies, navigate) {
    if ((!cookies.isLoggedIn) || (cookies.SD$54NGGFH63DFN$HD5dfhggfasrt7thgfuf5434)) {
        navigate("/");
      }
      
      if(!sessionStorage.getItem("fdasdfaRETRFDGFDH234%82ERXB23!45sgf") || (sessionStorage.getItem("fdasdfaRETRFDGFDH234%82ERXB23!45sgf") == "DSFSDhew234%*dgffd126DR3$%sDFGF")) {
        navigate("/");
      }
}